module.exports = __webpack_public_path__ + "static/star-45dd54703cf1537d439bc358c680762c.png";